import "../styling/loader.scss";

const Loader = () => {
  return (
    <div id="loader">
      <div id="circle"></div>
    </div>
  );
};

export default Loader;
